(() => {
  class ToggleNew extends HTMLElement {
    constructor() {
      super();
      this.checkbox = this.querySelector("input[type=checkbox]");
      this.on = this.querySelector("[data-on]");
      this.off = this.querySelector("[data-off]");
    }

    connectedCallback() {
      this.on.addEventListener("click", this.activate.bind(this));
      this.off.addEventListener("click", this.deactivate.bind(this));
    }

    activate() {
      this.checkbox.checked = true;
      this.checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    }

    deactivate() {
      this.checkbox.checked = false;
      this.checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  if (!customElements.get("toggle-new")) customElements.define("toggle-new", ToggleNew);
})();
